// Función para extraer texto plano del HTML
const getPlainText = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.textContent || "";
};

export function Post({post, configuration}) {
  const textoLimpio = getPlainText(post.content);
  const limite = 180;
  // Cortamos el texto y añadimos puntos suspensivos si supera el límite
  const resumen = textoLimpio.length > limite 
    ? textoLimpio.substring(0, limite) + '...' 
    : textoLimpio;
  return (
    <div className="card card-vertical">
      <div className="card-header">
        <img src={post.image ? post.image : "/static/imgs/default_post.jpg" } className="card-img-top" alt={post.title} />
      </div>
      <div className="card-body">
        <h5 className="card-title">{post.title}</h5>
        <p className="card-text">{resumen}</p>
        <a href={post.url} className="card-link">{configuration.translations.moreinfo} <i className="fa-solid fa-arrow-right-long"></i></a>
      </div>
    </div>
  );
}
